export default {
  setCount: ({ commit }, payload) => {
    commit('SET_COUNT', payload)
  },

  setCountApplicationsIncomplete: ({ commit }, payload) => {
    commit('SET_APPLICATIONS_INCOMPLETE', payload)
  },

  setPersonalityTestNotification: ({ commit }, payload) => {
    commit('SET_PERSONALITY_TEST_NOTIFICATION', payload)
  },

  setSuggestedNotifications: ({ commit }, payload) => {
    commit('SET_SUGGESTED_NOTIFICATIONS', payload)
  },
  setRedeemTransactions: ({ commit }, payload) => {
    commit('SET_REDEEM_TRANSACTIONS', payload)
  },
  setUserRedeem: ({ commit }, payload) => {
    commit('SET_USER_REDEEM', payload)
  },

  async fetchIncompleteApplications({ commit, state }, $axios) {
    if (state.applicationsLoaded) { return }

    try {
      const response = await $axios.get('/proxysbapi/auth/candidate/applications', {
        params: { campaignStatus: 'active', page: 0, size: 100 }
      })
      const applications = response.data?.content || []
      const incompleteCount = applications.filter(app => !app.applicationIsComplete).length
      commit('SET_APPLICATIONS_INCOMPLETE', incompleteCount)
    } catch {
      commit('SET_APPLICATIONS_INCOMPLETE', 0)
    }
    commit('SET_APPLICATIONS_LOADED', true)
  },

  async refreshIncompleteApplications({ commit, dispatch }, $axios) {
    commit('SET_APPLICATIONS_LOADED', false)
    await dispatch('fetchIncompleteApplications', $axios)
  }
}
